<template>
  <div>
    <NavItem v-show="isShowMenu"></NavItem>
    <el-container
      class="elContainer"
      :style="{ left: menuIsCollapse ? '64px' : '200px' }"
      :class="{ 'elContainer-t': menuIsCollapse }"
    >
      <app-header v-show="isShowMenu"></app-header>
      <div class="mainRoute">
        <div class="contentRoute">
          <div class="mainBackground">
            <transition name="fade-transform" mode="out-in">
              <keep-alive :include="cachedViewsName">
                <!--<keep-alive>-->
                <router-view :key="$route.fullPath"></router-view>
              </keep-alive>
            </transition>
          </div>
        </div>
      </div>
    </el-container>

    <el-dialog title="消息提醒" :visible:sync="msgLog" width="300px">
    </el-dialog>
  </div>
</template>

<script>
import NavItem from "./navItem";
import AppHeader from "./appHeader";

export default {
  name: "index",
  components: {
    AppHeader,
    NavItem,
  },
  computed: {
    cachedViewsName() {
      // console.log(this.$store.state.tagsView.cachedViewsName)
      return this.$store.state.tagsView.cachedViewsName;
    },
    menuIsCollapse() {
      return this.$store.getters.menuIsCollapse;
    },
  },
  data() {
    return {
      msgLog: false,
      isShowMenu:true,
    };
  },
  mounted() {
    this.msgLog = true;
    // this.routePath = this.$route.path;
    // let index = this.routePath.indexOf('/', this.routePath.indexOf('/', this.routePath.indexOf('/') + 1) + 1);
    // let resultUrl = this.routePath.substring(0, index);
    this.handleUrl();
    console.log("$baseUrl",this.$baseUrl)
  },
  methods: {
    handleUrl() {
      let str = this.$route.path;
      let subStr = "/work/shipPlan/stowageMap/";
      if (str.indexOf(subStr) !== -1) {
        this.isShowMenu = false;
      } else {
        this.isShowMenu = true;
      }


    },
  },
};
</script>

<style scoped>
.elContainer {
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  left: 200px;
  top: 0;
  width: calc(100% - 200px);
}
.elContainer-t {
  width: calc(100% - 64px);
}
.mainRoute {
  width: 100%;

  background-color: #f3f3f3;
  margin-top: 90px;
}

.contentRoute {
  padding: 15px;
}

.mainBackground {
  padding: 15px 20px;
  background-color: #fff;
  box-shadow: 0 1px 1px 0px rgba(0, 34, 77, 0.06);
  min-width: 993px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue